import { ResultMap, Success } from "@pdfking/errors"
import type { Validator } from "@pdfking/forms"
import type { ImpositionSchema } from "@pdfking/imposition/internal"
import { SortBy } from "@pdfking/tfunc"

/**
 * Top-level form validator for the `marking` field. Mirrors Python
 * `get_processors` ordering (`packing/presets/concrete.py:470-489`, sorted by
 * `sequence`): sorts `marking` by `(sequence, selection order)` so the pipeline
 * always sees processors in a stable, deterministic order.
 */
export const ValidateJobProcessors: Validator<ImpositionSchema> = results => ({
  ...results,
  marking: ResultMap(results.marking, value => Success(SortBy(value, p => p.sequence))),
})
